// extracted by css-extract-rspack-plugin
export default {"tooltipHost":"tooltip-host--eMhE9VIGSU0M1BtI","tooltipHostBlokoLayer":"tooltip-host_bloko-layer--NKraAnhvrM82UAXY"};